import { createContext, useContext, useEffect, useState } from "react";
import { Color } from "../../entities/color";
import { api } from "../../services/api";

const FilterContext = createContext();

export const useFilter = () => useContext(FilterContext);

export const FilterContextProvider = ({ children }) => {
	const [colors, setColors] = useState();
	const [filter, setFilter] = useState();
	const [filterAPI, setFilterAPI] = useState(null);

	const toggleColorsCheckboxes = (evt, index) => {
		const newColor = [...filter?.color];
		newColor.fill({ isChecked: false });
		const isChecked = filter?.color[index].isChecked;
		newColor[index] = !isChecked
			? { isChecked: true, color: evt.target.value }
			: { isChecked: false };
		setFilter({ ...filter, color: newColor });
	};

	const handleSliderChange = (evt, newValue) => {
		setFilter({ ...filter, price: newValue });
	};

	const applyFilter = () => {
		const minFilter = { ...filter };
		for (const prop in minFilter) {
			if (prop !== "price") {
				minFilter[prop] = minFilter[prop].find(
					(element) => element.isChecked === true
				);
			}
		}
		setFilterAPI(minFilter);
	};

	const resetFilter = () => {
		setFilter({
			color: Array(colors?.length).fill({ isChecked: false }),
			price: [2000, 5000],
		});
		setFilterAPI(null);
	};

	useEffect(() => {
		api.products
			.listColors()
			.then((res) => res.json())
			.then((colors) => {
				const allColors = [];
				colors.forEach(({ id, descripcion, hex }) =>
					allColors.push(new Color(id, descripcion, hex))
				);
				setColors(allColors);
			})
			.catch((err) => console.log("Error en el useEffect: ", err));

		setFilter({
			color: Array(colors?.length).fill({ isChecked: false }),
			price: [500, 15000],
		});
	}, [colors?.length]);

	return (
		<FilterContext.Provider
			value={{
				filter,
				filterAPI,
				setFilterAPI,
				colors,
				toggleColorsCheckboxes,
				handleSliderChange,
				applyFilter,
				resetFilter,
			}}
		>
			{children}
		</FilterContext.Provider>
	);
};

export default FilterContext;
